// import vlSDK from "toolchain-landingpage-web-sdk";
import Axios from 'axios'
var axios = Axios.create()
axios.defaults.timeout = 30000;
axios.defaults.withCredentials = true;

export const getParams = () => {
  let query = window.location.search.substring(1);
  query = query.replace("#", "");
  let res: any = {};
  window.location.search
    .substring(1)
    .split("&")
    .forEach((item) => {
      let [key, val] = item.split("=");
      key && (res[key] = val);
    });
  return res;
};

const getAppHost = () => {
  let env = process.env.NODE_ENV;
  let origindomain = document.domain;
  if ((env && env.startsWith("dev")) || origindomain.endsWith("vechaindev.com") && !origindomain.endsWith("mystory-test.vechaindev.com")) {
    return "https://baas-v.vechaindev.com/v2/data";
  }
  else if ((env && env.startsWith("test")) || origindomain.endsWith("vechaintest.com") || origindomain.endsWith("mystory-test.vechaindev.com")) {
    return "https://baas-v.vechaintest.com/v2/data";
  }
  else if ((env && env.startsWith("staging")) || origindomain.endsWith("vtho.net")) {
    return "https://v-baas-ali-hk-deploy.vtho.net/v2/data";
  }
  return "https://api.vevids.com/v2/data";
};
const getTxAppHost = () => {
  let env = process.env.NODE_ENV;
  let origindomain = document.domain;

  if (env && env.startsWith("dev")|| origindomain.endsWith("vechaindev.com")&& !origindomain.endsWith("mystory-test.vechaindev.com")) {
    return "https://baas-v.vechaindev.com/v1/txlist";
  }
  if ((env && (env.startsWith("test") || env.startsWith("newtest"))) || origindomain.endsWith("vechaintest.com") || origindomain.endsWith("mystory-test.vechaindev.com") ){
    return "https://baas-v.vechaintest.com/v1/txlist";
  }
  if ((env && env.startsWith("staging")) || origindomain.endsWith("vtho.net")) {
    return "https://v-baas-ali-hk-deploy.vtho.net/v1/txlist";
  }
  return "https://api.vevids.com/v1/txlist";
};
export const getSupplyOrgHost = () => {
  let env = process.env.NODE_ENV;
  let origindomain = document.domain;

  if (env && env.startsWith("dev")|| origindomain.endsWith("vechaindev.com")) {
    return "https://toolchain-vapp.vechaindev.com/vapp/open/landingPageQuery/v1/queryInfo";
  }
  if ((env && (env.startsWith("test") || env.startsWith("newtest"))) || origindomain.endsWith("vechaintest.com")|| origindomain.endsWith("mystory-test.vechaindev.com") ){
    return "https://toolchain-vapp-v2.vechaintest.com/vapp/open/landingPageQuery/v1/queryInfo";
  }
  if ((env && env.startsWith("staging")) || origindomain.endsWith("vtho.net")) {
    return "https://toolchain-vapp.vtho.net/vapp/open/landingPageQuery/v1/queryInfo";
  }

  if(origindomain.endsWith("veplatform.com")){
    return "https://vapp.veplatform.com/vapp/open/landingPageQuery/v1/queryInfo";
  }
  return "https://vapp.veplatform.cn/vapp/open/landingPageQuery/v1/queryInfo";
};
const getInternalAppHost = () => {
  let env = process.env.NODE_ENV;
  let origindomain = document.domain;

  if (env && env.startsWith("dev")|| (origindomain.endsWith("vechaindev.com") && !origindomain.endsWith("mystory-test.vechaindev.com"))) {
    return "https://toolchain-workspace.vechaindev.com/operatorapi/landingpage/preview/all";
  }
  else if ((env && (env.startsWith("test") || env.startsWith("newtest"))) || origindomain.endsWith("vechaintest.com") || origindomain.endsWith("mystory-test.vechaindev.com")){
    return "https://toolchain-workspace.vechaintest.com/operatorapi/landingpage/preview/all";
  }
  else if ((env && env.startsWith("staging")) || origindomain.endsWith("vtho.net")) {
    return "https://toolchain-operator-deploy.vtho.net/operatorapi/landingpage/preview/all";
  }

  if(origindomain.endsWith("veplatform.com")){
    return "https://workspace.veplatform.com/operatorapi/landingpage/preview/all";
  }
  return "https://workspace.veplatform.cn/operatorapi/landingpage/preview/all";
};

const getModelHost = () => {
  let env = process.env.NODE_ENV;
  let origindomain = document.domain;

  if (env && env.startsWith("dev")|| (origindomain.endsWith("vechaindev.com")&& !origindomain.endsWith("mystory-test.vechaindev.com"))) {
    return "https://baas-v.vechaindev.com/v2/model";
  }
  else if ((env && (env.startsWith("test") || env.startsWith("newtest"))) || origindomain.endsWith("vechaintest.com") || origindomain.endsWith("mystory-test.vechaindev.com") ){
    return "https://baas-v.vechaintest.com/v2/model";
  }
  else if ((env && env.startsWith("staging")) || origindomain.endsWith("vtho.net")) {
    return "https://v-baas-ali-hk-deploy.vtho.net/v2/model";
  }
  return "https://api.vevids.com/v2/model";
};

const getMintData = () => {
  let env = process.env.NODE_ENV;
  let origindomain = document.domain;

  if (env && env.startsWith("dev")|| (origindomain.endsWith("vechaindev.com") && !origindomain.endsWith("mystory-test.vechaindev.com"))) {
    return "https://baas-v.vechaindev.com/v1/nft/mintData";
  }
  if ((env && (env.startsWith("test") || env.startsWith("newtest"))) || origindomain.endsWith("vechaintest.com") || origindomain.endsWith("mystory-test.vechaindev.com") ){
    return "https://baas-v.vechaintest.com/v1/nft/mintData";
  }
  if ((env && env.startsWith("staging")) || origindomain.endsWith("vtho.net")) {
    return "https://v-baas-ali-hk-deploy.vtho.net/v1/nft/mintData";
  }
  return "https://api.vevids.com/v1/nft/mintData";
}

// export const vidTypes: any = {
//   sku: process.env.VUE_APP_SKU,
//   activity: process.env.VUE_APP_ACTIVITY,
//   batch: process.env.VUE_APP_BATCH,
//   track: process.env.VUE_APP_TRACK
// };

export const vidTypes: any = {
  sku: 'sku',
  // sku: 'sku_e69a',
  activity: 'customizedDisplayInfo',
  buinfo: 'buinfo',
  batch: process.env.VUE_APP_BATCH,
  track: 'trackinfo',
  customDcps: 'dcp1,dcp2,dcp3,dcp4,dcp5,dcp6,dcp7,dcp8,dcp9,dcp10'
};

export const vlSDKRequest = (
  query = ["sku", "activity", "batch", "track", 'buinfo'], language: any = undefined
) => {
  console.log("lang:", language)
  var params = getParams();

  var internal = params["internal"] || false;

  var url = getAppHost();
  if (internal == true || internal == "true") {
    url = getInternalAppHost();
  }

  let lang = language || navigator.language
  lang = (lang == 'zh-CN' ? 'zh-CN': 'en-US');
  (window as any).vlSDK.config({
    __url: url,
    __isUUID: false,
    internal: internal,
    cache: false,
    lang: lang
  });
  var types = [];
  for (let item of query) {
    if(item == 'batch'){
      let batchs = vidTypes[item].split(',') || []
      for(let i in batchs){
        types.push(batchs[i]);
      }
    }else if(item == 'sku'){
      let skulist = vidTypes[item].split(',') || []
      for(let i in skulist){
        types.push(skulist[i]);
      }
    }else if(item == 'customDcps'){
      let customDcps = vidTypes[item].split(',') || []
      for(let i in customDcps){
        types.push(customDcps[i]);
      }
    }else{
      types.push(vidTypes[item]);
    }
  }
  let vid = params["vid"] || undefined;
  let parameters: any = {
    types,
  };
  if (vid) {
    parameters["vid"] = vid;
  }
  if(language){
    parameters['language'] = language
  }

  return (window as any).vlSDK.fetch(parameters);
};
export const vlTxSDKRequest = () => {
  var params = getParams();

  var internal = params["internal"] || false;

  var url = getTxAppHost();
  if (internal == true || internal == "true") {
    url = getInternalAppHost();
  }
  (window as any).vlSDK.config({
    __url: url,
    __isUUID: false,
    internal: internal,
    cache: false,
  });
  let vid = params["vid"] || undefined;
  let parameters: any = {
    vid: vid,
  };

  return (window as any).vlSDK.fetch(parameters);
};


axios.interceptors.response.use(function (res) {
  var _response = res.data,
      code = _response.code,
      message = _response.message,
      data = _response.data;

  if (code === 'common.success') {
    var displayType = data.displayType,
        advert = data.advert,
        jsonData = data.jsonData;
    // var trackinfo = jsonData.trackinfo; // getPlugins('popbar').run(data)
    // 符合条件 插入小黄条
    // if( displayType === 'simple' || advert === 'pro'){
    // popbar()
    // getPlugins('popbar').run(data)
    // }

    var _res = {
      code: code,
      message: 'ok',
      displayType: displayType,
      data: data
    }; // if (trackinfo) {
    //   return setAddress(trackinfo, 0)
    //     .then(() => {
    //       return res
    //     })
    //     .catch(() => {
    //       return res
    //     })
    // }

    return _res;
  } else {
    return Promise.reject({
      code: 0,
      message: code,
      data: null
    });
  }
}, function (error) {
  var _response2 = error.data,
      message = _response2.message,
      code = _response2.code,
      data = _response2.data;

  return Promise.reject({
    code: code,
    message: message,
    data: data
  });
});

export const vlModelRequest = () => {

  var params = getParams();

  var internal = params["internal"] || false;

  var url = getModelHost();
  
  // vlSDK.config({
  //   __url: url,
  //   __isUUID: false,
  //   internal: internal,
  //   cache: false,
  // });
  let vid = params["vid"] || undefined;
  let parameters: any = {
    vid: vid,
    vidType: "VID"
  };

  return axios.post(url, parameters)

  // return vlSDK.fetch(parameters);
}

export const vlMintRequest = () => {

  var params = getParams();

  var internal = params["internal"] || false;

  var url = getMintData();

  let vid = params["vid"] || undefined;
  let parameters: any = {
    vid: vid,
    vidType: "VID"
  };

  return axios.post(url, parameters)

  // return vlSDK.fetch(parameters);
}
export default vlSDKRequest;
